export const supportFarmList = {
  name: "BWS Supported Farm Tokens List",
  version: "1.0.0",
  tokens: [
    {
      name: "USDC.e-AVAX",
      poolNumber: "39",
      protocolName: "TraderJoe",
      contract: "0xd6a4F121CA35509aF06A0Be99093d08462f53052",
      symbol0Name: "USDC.e",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664/logo.png",
      symbol1Name: "WAVAX",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol0address: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664",
      symbol1address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      network: "avaxc",
      lpAddress: "0xa389f9430876455c36478deea9769b7ca4e3ddb1",
    },
    {
      name: "MIM-WAVAX",
      poolNumber: "43",
      protocolName: "TraderJoe",
      contract: "0xd6a4F121CA35509aF06A0Be99093d08462f53052",
      symbol0Name: "MIM",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x130966628846BFd36ff31a822705796e8cb8C18D/logo.png",
      symbol1Name: "WAVAX",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol0address: "0x130966628846bfd36ff31a822705796e8cb8c18d",
      symbol1address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      network: "avaxc",
      lpAddress: "0x781655d802670bba3c89aebaaea59d3182fd755d",
    },
    {
      name: "WAVAX-USDT.e",
      poolNumber: "28",
      protocolName: "TraderJoe",
      contract: "0xd6a4F121CA35509aF06A0Be99093d08462f53052",
      symbol0Name: "WAVAX",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol1Name: "USDT.e",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xc7198437980c041c805A1EDcbA50c1Ce5db95118/logo.png",
      symbol0address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      symbol1address: "0xc7198437980c041c805a1edcba50c1ce5db95118",
      network: "avaxc",
      lpAddress: "0xed8cbd9f0ce3c6986b22002f03c6475ceb7a6256",
    },
    {
      name: "WETH.e-WAVAX",
      poolNumber: "26",
      protocolName: "TraderJoe",
      contract: "0xd6a4F121CA35509aF06A0Be99093d08462f53052",
      symbol0Name: "WETH.e",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB/logo.png",
      symbol1Name: "WAVAX",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol0address: "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
      symbol1address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      network: "avaxc",
      lpAddress: "0xfe15c2695f1f920da45c30aae47d11de51007af9",
    },
    {
      name: "xJOE",
      poolNumber: "24",
      protocolName: "TraderJoe",
      contract: "0xd6a4F121CA35509aF06A0Be99093d08462f53052",
      symbol0Name: "xJOE",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x6e84a6216eA6dACC71eE8E6b0a5B7322EEbC0fDd/logo.png",
      symbol1Name: "",
      symbol1Logo: "",
      symbol0address: "0x57319d41f71e81f3c65f2a47ca4e001ebafd4f33",
      symbol1address: "",
      network: "avaxc",
      lpAddress: "0x57319d41f71e81f3c65f2a47ca4e001ebafd4f33",
    },
    {
      name: "JOE-WAVAX",
      poolNumber: "0",
      protocolName: "TraderJoeV3",
      contract: "0x188bED1968b795d5c9022F6a0bb5931Ac4c18F00",
      symbol0Name: "JOE",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x6e84a6216eA6dACC71eE8E6b0a5B7322EEbC0fDd/logo.png",
      symbol1Name: "WAVAX",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol0address: "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd",
      symbol1address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      network: "avaxc",
      lpAddress: "0x454e67025631c065d3cfad6d71e6892f74487a15",
    },
    {
      name: "LINK.e-WAVAX",
      poolNumber: "29",
      protocolName: "TraderJoe",
      contract: "0xd6a4F121CA35509aF06A0Be99093d08462f53052",
      symbol0Name: "LINK.e",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x5947BB275c521040051D82396192181b413227A3/logo.png",
      symbol1Name: "WAVAX",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol0address: "0x5947bb275c521040051d82396192181b413227a3",
      symbol1address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      network: "avaxc",
      lpAddress: "0x6f3a0c89f611ef5dc9d96650324ac633d02265d3",
    },
    {
      name: "PTP-WAVAX",
      poolNumber: "28",
      protocolName: "TraderJoeV3",
      contract: "0x188bED1968b795d5c9022F6a0bb5931Ac4c18F00",
      symbol0Name: "PTP",
      symbol0Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x22d4002028f537599bE9f666d1c4Fa138522f9c8/logo.png",
      symbol1Name: "WAVAX",
      symbol1Logo:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png",
      symbol0address: "0x22d4002028f537599be9f666d1c4fa138522f9c8",
      symbol1address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
      network: "avaxc",
      lpAddress: "0xcdfd91eea657cc2701117fe9711c9a4f61feed23",
    },
  ],
};

export default supportFarmList;
